__turbopack_context__.v({
  "actionButton": "oP9daa_actionButton",
  "indicatorIndicator": "oP9daa_indicatorIndicator",
  "indicatorRoot": "oP9daa_indicatorRoot",
  "opened": "oP9daa_opened",
});
